/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC } from "react";
import { ModuleIds } from "src/globalTypes";
import { useIsDesktop } from "../../../hooks/viewport/useViewportCategory";
import DesktopOnlyView from "./components/DesktopOnlyView";
import MobileAndTabletView from "./components/MobileAndTabletView/MobileAndTabletView";
import { Header, navbarCss } from "./styles";

export type NavMenuProps = {
  hideLogin?: boolean;
  moduleIds: ModuleIds;
};

const NavMenu: FC<NavMenuProps> = (props) => {
  const isOnlyDesktop = useIsDesktop();

  return (
    <Header>
      <nav css={navbarCss}>
        {isOnlyDesktop ? (
          <DesktopOnlyView {...props} />
        ) : (
          <MobileAndTabletView {...props} />
        )}
      </nav>
    </Header>
  );
};

export default NavMenu;
